import { useAtomValue } from "jotai";

import { updateGolfBookingPayloadAtom } from "../../../atoms/selectors/UpdatePayloads/updateGolfBookingPayload/updateGolfBookingPayloadAtom";
import { useUpdateSingleSlotBookingMutation } from "./useUpdateSingleSlotBooking";

export const useRemoveCurrentPlayer = () => {
  const updateGolfBookingPayload = useAtomValue(updateGolfBookingPayloadAtom);

  const [handleUpdateBooking, isUpdating] =
    useUpdateSingleSlotBookingMutation();

  const bookingId = updateGolfBookingPayload?.bookingId;

  const handleRemoveCurrentPlayer = (
    currentMemberId: string,
    successCallback?: () => void
  ) => {
    const memberRoundsWithoutCurrentMember =
      updateGolfBookingPayload?.memberRounds?.filter(
        (p) => p?.playerId !== currentMemberId
      );

    handleUpdateBooking(
      {
        bookingId: bookingId ?? "",
        ...updateGolfBookingPayload,
        memberRounds: memberRoundsWithoutCurrentMember,
        notifyMember: true,
      },
      successCallback
    );
  };

  return [handleRemoveCurrentPlayer, isUpdating] as const;
};
